import { render, staticRenderFns } from "./ExpedientInvoicesComponent.vue?vue&type=template&id=657901de&scoped=true&lang=pug"
import script from "./ExpedientInvoicesComponent.vue?vue&type=script&lang=ts"
export * from "./ExpedientInvoicesComponent.vue?vue&type=script&lang=ts"
import style0 from "./ExpedientInvoicesComponent.vue?vue&type=style&index=0&id=657901de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657901de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('657901de')) {
      api.createRecord('657901de', component.options)
    } else {
      api.reload('657901de', component.options)
    }
    module.hot.accept("./ExpedientInvoicesComponent.vue?vue&type=template&id=657901de&scoped=true&lang=pug", function () {
      api.rerender('657901de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/expedients/ExpedientInvoices/ExpedientInvoicesComponent.vue"
export default component.exports